import API from "../BaseURL";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


export async function getAllTanksByExploitation(exploitation_id) {
    const res = API.get(`/tanks/exploitation/${exploitation_id}`, configJson);
    return res;
}

export async function createTank(data) {
    const res = API.post(`/tanks/`, data, configJson);
    return res;
}

export async function updateTank(tank_id, data) {
    const res = API.put(`/tanks/${tank_id}/`, data, configJson);
    return res;
}

export async function deleteTank(tank_id) {
    const res = API.delete(`/tanks/${tank_id}/`, configJson);
    return res;
}

export async function getTank(tank_id) {
    const res = API.get(`/tanks/${tank_id}`, configJson);
    return res;
}